import axios from 'axios';
import  config  from "../config";
import { endExpiredSession, isAuthErrorStatus } from '../utils/authSession';

const instance = axios.create({
  baseURL: config.BASE_URL,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token-id');
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
})

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAuthErrorStatus(error?.response?.status)) {
      endExpiredSession();
    }

    return Promise.reject(error);
  }
);

export default instance;
